import { slugify } from "@/lib/utils";

type ProviderUrlSource = {
  slug: string;
  name?: string | null;
};

export function getProviderUrlSlug(provider: ProviderUrlSource) {
  const rawSlug = provider.slug.trim();

  if (!rawSlug) {
    return "";
  }

  if (!/\s/.test(rawSlug)) {
    return rawSlug;
  }

  return slugify(rawSlug);
}

export function buildProviderProfilePath(provider: ProviderUrlSource) {
  const slug = getProviderUrlSlug(provider);
  return `/provider/${encodeURIComponent(slug)}`;
}
